import { Directive, Injectable } from '@angular/core';
import { BarraConsultaComponent } from './barra-consulta.component';

@Injectable({
    providedIn: 'root'
  })
@Directive()
export class BarraConsultaServiceService extends BarraConsultaComponent {

}
